export const OFFSET_QUERY_VAR = 'pl-offset';
export const PAGE_SIZE_QUERY_VAR = 'pl-pageSize';
export const SEARCH_QUERY_QUERY_VAR = 'query';
export const SORTING_QUERY_VAR = 'pl-sortby';
